<form [formGroup]="form" [id]="formId" autocomplete="off">
  <!-- gender -->
  <div class="tw-w-full">
    <custom-select-search
      label="common.gender"
      [items]="
        $any([
          { value: VocalistGender.Male, name: 'common.male' | translate },
          { value: VocalistGender.Female, name: 'common.female' | translate }
        ])
      "
      [control]="form?.get('gender')"
      optionTitle="name"
      optionValue="value"
      [removable]="false"
      [(value)]="gender"
    >
    </custom-select-search>
  </div>

  <!-- voiceText -->
  <div class="tw-w-full">
    <div class="tw-relative">
      <div #voiceTextTextArea>
        <form-textarea
          class="tw-w-full"
          label="common.text"
          [(value)]="voiceText"
          [control]="form?.get('voiceText')"
          [rows]="3"
          [placeholder]="'messages.enterYourText'|translate"
        >
        </form-textarea>
      </div>

      <!-- clean textbox -->
      <a
        class="tw-my-1 tw-cursor-pointer"
        *ngIf="model.voiceText; else disableEraser"
        (click)="clearText()"
      >
        <i
          class="clear-btn mdi mdi-eraser text-danger mdi-22px tw-mt-1"
          [matTooltip]="'common.clear' | translate"
        ></i>
      </a>
      <ng-template #disableEraser>
        <a class="disable tw-my-1">
          <i class="clear-btn mdi mdi-eraser text-danger mdi-22px tw-mt-1"></i>
        </a>
      </ng-template>
    </div>
  </div>

  <div
    class="btn-group btn-group-sm tw-mt-1 tw-mb-4 m-btn-group--pill m-btn-group--air"
  >
    <button
      matRipple
      type="button"
      class="btn btn-mini border border-secondary btn-sm tw-text-gray-800"
      matTooltip=","
      matTooltipPosition="above"
      matTooltipClass="tanvin-tooltip"
      (click)="onAddTanvinLetterToVoiceText(', ')"
    >
      {{ "pages.voiceMessages.textToVoiceConvertor.delay" | translate }}
      <!-- <span>,</span> -->
    </button>
    <button
      matRipple
      type="button"
      class="btn btn-mini border border-secondary btn-sm tw-text-gray-800"
      matTooltip=" ِ"
      matTooltipPosition="above"
      matTooltipClass="tanvin-tooltip"
      (click)="onAddTanvinLetterToVoiceText(' ِ ')"
    >
      {{ "pages.voiceMessages.textToVoiceConvertor.kasre" | translate }}
      <!-- <span> ِ</span> -->
    </button>
    <button
      matRipple
      type="button"
      class="btn btn-mini border border-secondary btn-sm tw-text-gray-800"
      matTooltip=" َ"
      matTooltipPosition="above"
      matTooltipClass="tanvin-tooltip"
      (click)="onAddTanvinLetterToVoiceText(' َ ')"
    >
      {{ "pages.voiceMessages.textToVoiceConvertor.fathe" | translate }}
      <!-- <span> َ</span> -->
    </button>
    <button
      matRipple
      type="button"
      class="btn btn-mini border border-secondary btn-sm tw-text-gray-800"
      matTooltip=" ُ"
      matTooltipPosition="above"
      matTooltipClass="tanvin-tooltip"
      (click)="onAddTanvinLetterToVoiceText(' ُ ')"
    >
      {{ "pages.voiceMessages.textToVoiceConvertor.zame" | translate }}
      <!-- <span> َُ</span> -->
    </button>
    <button
      matRipple
      type="button"
      class="btn btn-mini border border-secondary btn-sm tw-text-gray-800"
      matTooltip=" ّ"
      matTooltipPosition="above"
      matTooltipClass="tanvin-tooltip"
      (click)="onAddTanvinLetterToVoiceText(' ّ ')"
    >
      {{ "pages.voiceMessages.textToVoiceConvertor.tashdid" | translate }}
      <!-- <span> ّ</span> -->
    </button>
    <button
      matRipple
      type="button"
      class="btn btn-mini border border-secondary btn-sm tw-text-gray-800"
      matTooltip=" ْ"
      matTooltipPosition="above"
      matTooltipClass="tanvin-tooltip"
      (click)="onAddTanvinLetterToVoiceText(' ْ ')"
    >
      {{ "pages.voiceMessages.textToVoiceConvertor.sokoon" | translate }}
      <!-- <span> ْ </span> -->
    </button>
  </div>

  <div class="tw-flex tw-items-center">
    <!-- play -->
    <button
      class="btn bg-gradient-success text-white tw-w-1/5"
      (click)="onConvertTextToVoice()"
      [disabled]="!voiceText"
    >
      <span [class.ml-3]="loading">{{ "common.play" | translate }}</span>
      <i *ngIf="!loading" class="mdi mdi-play mdi-24px text-white"></i>
      <span
        *ngIf="loading"
        class="spinner-grow spinner-grow-sm text-white"
        role="status"
        aria-hidden="true"
      ></span>
    </button>

    <!-- download -->
    <button
      [disabled]="!voiceFileSrc"
      class="btn bg-gradient-info text-white tw-mx-2 tw-w-1/5"
      (click)="onDownload()"
    >
      {{ "common.download" | translate }}
      <i class="mdi mdi-download mdi-24px text-white"></i>
    </button>

    <!-- audio -->
    <app-audio-controller
      class="tw-w-full"
      [audioSrc]="voiceFileSrc"
      [palyAgain]="palyAgain"
    ></app-audio-controller>
  </div>
</form>
